export const alert = {
    state: {
        status: 'idle',
        alert: {},
        alertEdited: {}
    },
    mutations: {
        SET_ALERT_STATUS(state, status) {
            state.status = status
        },
        SET_ALERT(state, alert) {
            state.alert = alert
        },
        SET_ALERT_EDITED(state, alert) {
            this.$vue.set(state, 'alertEdited', alert)
        }
    },
    actions: {
        fetchAlert({ state, commit }, payload) {
            commit('SET_ALERT', null)
            commit('SET_ALERT_STATUS', 'loading')
            return this.$api.get(`api/alerts/${payload}.json`).then(response => {
                commit('SET_ALERT', response.data.data)
                commit('SET_ALERT_STATUS', 'idle')
            }).catch(error => {
                commit('SET_ALERT_STATUS', 'error')
                return Promise.reject(error)
            })
        },
        addAlert({ state, commit }, payload) {
            return new Promise((resolve, reject) => {
                commit('SET_ALERT_STATUS', 'saving')
                this.$api.post('api/alerts.json', payload).then(response => {
                    commit('SET_ALERT_STATUS', 'idle')
                    resolve()
                }).catch(error => {
                    commit('SET_ALERT_STATUS', 'error')
                    reject(error)
                })
            })
        },
        updateAlert({ state, commit }, payload) {
            return new Promise((resolve, reject) => {
                commit('SET_ALERT_STATUS', 'saving')
                this.$api.put(`api/alerts/${payload.id}.json`, payload.body).then(response => {
                    commit('SET_ALERT_STATUS', 'idle')
                    resolve()
                }).catch(error => {
                    commit('SET_ALERT_STATUS', 'error')
                    reject(error)
                })
            })
        },
        setAlertEdited({ commit }, payload) {
            commit('SET_ALERT_EDITED', payload)
        },
        resetAlertEdited({ commit }) {
            commit('SET_ALERT_EDITED', {})
        }
    },
    getters: {
        alertStatus: (state) => {
            return state.status
        },
        alert: (state) => {
            if(state.alert) {
                return state.alert
            }
        },
        alertEdited: (state) => {
            if(state.alertEdited) {
                return state.alertEdited
            }
        }
    }
}
